import { render, staticRenderFns } from "./boxStyle.vue?vue&type=template&id=25f55aef&scoped=true"
import script from "./boxStyle.vue?vue&type=script&lang=js"
export * from "./boxStyle.vue?vue&type=script&lang=js"
import style0 from "./boxStyle.vue?vue&type=style&index=0&id=25f55aef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f55aef",
  null
  
)

export default component.exports